import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


function renderOption(option) {
	return (
		<option key={option.value} value={option.value}>
			{option.displayValue}
		</option>
	);
}

function renderGroup(group) {
	return (
		<optgroup key={group.label} label={group.label}>
			{group.options.map(renderOption)}
		</optgroup>
	);
}

const Dropdown = (props) => {
	let dropdownClass = classNames('Dropdown form-group', props.className);
	let selectClass = classNames({
		[(props.select && props.select.className) || '']: true,
		'form-control': true,
		'is-invalid': props.touched && props.invalidFeedback
	});

	return (
		<div className={dropdownClass}>
			<label> {props.label} </label>
			<select {...props.select} className={selectClass}>
				{props.placeholderText && <option disabled value=''>{props.placeholderText}</option>}
				{props.valueList.map(optionOrGroup => {
					const isGroup = optionOrGroup?.options != null;
					return isGroup ? renderGroup(optionOrGroup) : renderOption(optionOrGroup);
				})}
			</select>

			{props.touched && props.invalidFeedback &&
				<div className='invalid-feedback'>
					{props.invalidFeedback}
				</div>
			}
		</div>
	);
};


const SelectOptionType = PropTypes.shape({
	value: PropTypes.any.isRequired,
	displayValue: PropTypes.string.isRequired
});

const SelectGroupType = PropTypes.shape({
	label: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(SelectOptionType)
});

const ValueListType = PropTypes.arrayOf(
	PropTypes.oneOfType([
		SelectOptionType,
		SelectGroupType
	])
);

Dropdown.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	select: PropTypes.shape({
		className: PropTypes.string,
		value: PropTypes.string,
		onChange: PropTypes.func,
		onBlur: PropTypes.onBlur
	}).isRequired,
	placeholderText: PropTypes.string,
	valueList: ValueListType.isRequired,
	touched: PropTypes.bool,
	invalidFeedback: PropTypes.string
};

export default Dropdown;
